import styled from 'styled-components';
import { colors } from '@pingcap-inc/tidb-community-ui'

import logoSvg from './tidb-logo.svg?url';
import { SIZES } from '/src/theme';

export const Container = styled.div`
  display: flex;
  height: 100vh;
  align-items: stretch;
  justify-content: center;
  background-color: ${({ $size }) => ($size === SIZES.small ? 'white' : colors.M2)};
  min-height: 100vh;
`;

export const Main = styled.main`
  order: 1;
  flex: 1;
  box-sizing: content-box;
  background-color: ${colors.M1};
  display: flex;
  align-items: center;
  justify-content: center;

  & > div {
    width: 360px;
    padding: 24px;

    ${({ $size }) =>
        $size === SIZES.small &&
        `
    padding: 12px 12px 64px;
  `}
  }
`;

export const Logo = styled.img.attrs({ alt: 'logo', src: logoSvg })`
  display: block;
  margin: 0 auto;
`;

export const Title = styled.h2`
  font-size: 20px;
  line-height: ${28 / 20};
  color: ${colors.F1};
  font-weight: 600;
  text-align: center;
  margin: 24px 0 0;
`;

export const SubTitle = styled.p`
  font-size: 16px;
  line-height: ${24 / 16};
  color: ${colors.F2};
  font-weight: 400;
  text-align: center;
  margin: 0 0 32px;
`;

export const Side = styled.aside`
  background: ${colors.M2};

  flex: 1;
  order: 0;
  display: ${({ $size }) => ([SIZES.small, SIZES.middle].includes($size) ? 'none' : 'flex')};
  align-items: center;
  justify-content: center;

  p.headline {
    text-align: center;
    color: ${colors.F2};
  }

  img {
    display: flex;
    margin: 0 auto 24px;
  }

  h3 {
    font-size: 24px;
  }

  p, h3, h4 {
    color: ${colors.F1};
  }

  & > div {
    padding: 24px;
  }
`
